export { default } from './EmptyTicketsList';
